module.exports = __webpack_public_path__ + "img/hasklig-light.6818d4df.png";